import { toast } from 'react-toastify';
import logoLight from '../../assets/images/logo/beconnectlogo.jpg';
import logoDark from '../../assets/images/logo/beconnectlogodark.jpg'

export function showSystemNotification({ message, title, url }) {
    const isSystemDarkMode = () =>
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches;



    if (askForNotificationPermission()) {
        const notification = new Notification(title, {
            tag: title,
            body: message,
            icon: isSystemDarkMode ? logoDark : logoLight,
        });

        notification.onclick = function () {
            window.open('http://localhost:3004' + url);
        };

    } else {
        toast.info(message);
    }
}


export function askForNotificationPermission() {
    if (Notification.permission === "granted") return true;
    else if (Notification.permission === "denied") {
        Notification.requestPermission().then(permission => {
            if (permission === "granted") {
                toast.success("Permission Granted 😀")
                return true;
            }
        });
    } else {
        Notification.requestPermission().then(permission => {
            if (permission === "granted") {
                toast.success("Permission Granted 😀")
                return true;
            } else {
                toast.error("Ohh Oh! Permission Needed 🥺");
                return false;
            }
        });
    }
}